import { supabase } from "@/lib/supabase";


export const pricingService = {
  // Fetch all active pricing plans
  async getPricingPlans() {
    try {
      const { data, error } = await supabase
        .from('pricing_plans')
        .select('*')
        .eq('is_active', true)
        .order('display_order', { ascending: true });

      if (error) throw error;
      
      // Transform data to match your component's expected structure
      return data.map(plan => ({
        id: plan.id,
        name: plan.name,
        badge: plan.badge,
        gst: plan.gst,
        price_monthly_inr: plan.price_monthly_inr,
        price_monthly_usd: plan.price_monthly_usd,
        original_price_monthly_inr: plan.original_price_monthly_inr,
        original_price_monthly_usd: plan.original_price_monthly_usd,
        price_yearly_inr: plan.price_yearly_inr,
        price_yearly_usd: plan.price_yearly_usd,
        original_price_yearly_inr: plan.original_price_yearly_inr,
        original_price_yearly_usd: plan.original_price_yearly_usd,
        credits: plan.credits,
        deliveryTime: plan.delivery_time,
        features: plan.features || [],
        strikethroughFeatures: plan.strikethrough_features || [],
        cta: plan.cta,
        note: plan.note,
        best: plan.best,
        highlight: plan.highlight
      }));
    } catch (error) {
      console.error('Error fetching pricing plans:', error);
      return [];
    }
  },

  // Optional: Add real-time subscription
  subscribeToPricingChanges(callback) {
    const subscription = supabase
      .channel('pricing_changes')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'pricing_plans'
        },
        (payload) => {
          callback(payload);
        }
      )
      .subscribe();

    return subscription;
  }
};